module.exports = __webpack_public_path__ + "static/media/CaptainAmerica.4be24fdc.png";